import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useGradeSubStatusRef } from "../../hooks/applicationHooks/useGradeSubStatusRef";
import { useCommonHooks } from "../../hooks";

import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface GradeSubStatusSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const GradeSubStatusSelect: React.FunctionComponent<
  GradeSubStatusSelectProps
> = ({ name, label, loading = false, ...fgSelectInputProps }) => {
  const { t } = useCommonHooks();
  const { subStatuses, subStatusesLoading } = useGradeSubStatusRef();

  return (
    <FGSelectInput
      label={label || t("CadreSubStatus")}
      name={name}
      items={subStatuses}
      loading={subStatusesLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default GradeSubStatusSelect;
